// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ndiv[data-v-25cd813e] {\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
